import { Context } from "csi/def/Context";
import declare from "dojo/_base/declare";
import StringConstructor from "csi/heading/String";
import Spec, { QuerySpec } from "csi/core/Spec";
import Heading from "csi/def/Heading";
import { stringNonTextFormatOperators } from "csi/middleware/customView/customViewDataManagementService";

const StringPhone = declare(StringConstructor, {
	queryOps: stringNonTextFormatOperators,
	
	/**
	 * @override
     * allow filter in custom view to select from existing values
     */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		const qs = this.inherited<QuerySpec>(arguments);
		qs.allowFilteringBySelectionOfExistingValues = true;
		return qs;
	},
});

export = StringPhone;